import { render, staticRenderFns } from "./InsLangSwitch.vue?vue&type=template&id=347497c5&scoped=true&"
import script from "./InsLangSwitch.vue?vue&type=script&lang=ts&"
export * from "./InsLangSwitch.vue?vue&type=script&lang=ts&"
import style0 from "./InsLangSwitch.vue?vue&type=style&index=0&id=347497c5&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347497c5",
  null
  
)

export default component.exports